/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface SubmitFormRequest
 */
export interface SubmitFormRequest {
    /**
     * 
     * @type {string}
     * @memberof SubmitFormRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitFormRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SubmitFormRequest
     */
    message: string;
    /**
     * 
     * @type {Array<ApiUserTasksGetPageParameter>}
     * @memberof SubmitFormRequest
     */
    locationIds: Array<ApiUserTasksGetPageParameter>;
    /**
     * 
     * @type {string}
     * @memberof SubmitFormRequest
     */
    contactEmail?: string | null;
}

/**
 * Check if a given object implements the SubmitFormRequest interface.
 */
export function instanceOfSubmitFormRequest(value: object): value is SubmitFormRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('locationIds' in value) || value['locationIds'] === undefined) return false;
    return true;
}

export function SubmitFormRequestFromJSON(json: any): SubmitFormRequest {
    return SubmitFormRequestFromJSONTyped(json, false);
}

export function SubmitFormRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitFormRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'email': json['email'],
        'message': json['message'],
        'locationIds': ((json['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterFromJSON)),
        'contactEmail': json['contactEmail'] == null ? undefined : json['contactEmail'],
    };
}

export function SubmitFormRequestToJSON(json: any): SubmitFormRequest {
    return SubmitFormRequestToJSONTyped(json, false);
}

export function SubmitFormRequestToJSONTyped(value?: SubmitFormRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'email': value['email'],
        'message': value['message'],
        'locationIds': ((value['locationIds'] as Array<any>).map(ApiUserTasksGetPageParameterToJSON)),
        'contactEmail': value['contactEmail'],
    };
}

